import './App.css';
import {Card, Image, Carousel, Flex} from 'antd';
import CarListings from './CarListings';

/* https://ant.design/components/overview */ 

/* import comingsoon from "./assets/comingsoon.jpg"; */

/* 2000 Ford Mustang Car */
import mustang1 from "./assets/cars/fm1.jpg";
import mustang2 from "./assets/cars/fm2.jpg";
import mustang3 from "./assets/cars/fm3.jpg";
import mustang4 from "./assets/cars/fm4.jpg";


/* 2018 Durango */
import durango181 from "./assets/cars/durango181.jpg";
import durango182 from "./assets/cars/durango182.jpg";
import durango183 from "./assets/cars/durango183.jpg";
import durango184 from "./assets/cars/durango184.jpg";

/* 2015 Sonic */
import sonic1 from "./assets/cars/sonic1.jpg";
import sonic2 from "./assets/cars/sonic2.jpg";
import sonic3 from "./assets/cars/sonic3.jpg";
import sonic4 from "./assets/cars/sonic4.jpg";

/* 1998 Silverado */
import silverado1 from "./assets/cars/silverado1.jpg";
import silverado2 from "./assets/cars/silverado2.jpg";
import silverado3 from "./assets/cars/silverado3.jpg";
import silverado4 from "./assets/cars/silverado4.jpg";

/* 2016 Escalade */
import escalade1 from "./assets/cars/escalade1.jpg";
import escalade2 from "./assets/cars/escalade2.jpg";
import escalade3 from "./assets/cars/escalade3.jpg";
import escalade4 from "./assets/cars/escalade4.jpg";
import escalade5 from "./assets/cars/escalade5.jpg";
import escalade6 from "./assets/cars/escalade6.jpg";


/* 2014 CTS */
import cts1 from "./assets/cars/cts1.jpg";
import cts2 from "./assets/cars/cts2.jpg";
import cts3 from "./assets/cars/cts3.jpg";
import cts4 from "./assets/cars/cts4.jpg";
import cts5 from "./assets/cars/cts5.jpg";
import cts6 from "./assets/cars/cts6.jpg";

/* 2017 Ford Explorer */
import police from "./assets/cars/police.jpg";

/* 2011 Dodge Nitro */
import nitro from "./assets/cars/nitro.jpg";

/* 2011 Jeep Cherokee */
import jeepCherokee from "./assets/cars/jeepCherokee.jpg";

/* 2015 Lincoln MKC */
import lincolnMKC from "./assets/cars/lincolnMKC.jpg";

/* 1988 Mercedes 560 SL */
import mercedes560 from "./assets/cars/mercedes560.jpg";
import mercedes5602 from "./assets/cars/mercedes5602.jpg";

/* 2022 Chevy Silverado 1500 4x4 6500 miles 59,000 */
import silverado2022 from "./assets/cars/silverado2022.jpg"; 

/* 2008 Nissan Altima */
import nissanAltima from "./assets/cars/nissanAltima.jpg";
import nissanAltima2 from "./assets/cars/nissanAltima2.jpg";
import nissanAltima3 from "./assets/cars/nissanAltima3.jpg";

/* 2004 Chevy Camero */
import mustangWhite from "./assets/cars/mustangWhite.jpg";
import mustangWhite2 from "./assets/cars/mustangWhite2.jpg";


/* 2015 Acadia */
import acadia from "./assets/cars/acadia.jpg";
import acadia2 from "./assets/cars/acadia2.jpg";
import acadia3 from "./assets/cars/acadia3.jpg";

/* Polaris  */
import polaris from "./assets/cars/polaris.jpg";
import polaris2 from "./assets/cars/polaris2.jpg";
import polaris3 from "./assets/cars/polaris3.jpg";

/* 2008 Silverado */
import silverado08 from "./assets/cars/silverado08.jpg";
import silverado081 from "./assets/cars/silverado081.jpg";
import silverado083 from "./assets/cars/silverado083.jpg";
import silverado084 from "./assets/cars/silverado084.jpg";

/* 2013 Edge */
import edge13 from "./assets/cars/edge13.jpg";
import edge1302 from "./assets/cars/edge1301.jpg";
import edge1301 from "./assets/cars/edge1302.jpg";
import edge1303 from "./assets/cars/edge1303.jpg";

function App() {
  return (
    <div>
        <div className="App">
          <div className="hero-image">
            <header className="App-header-2">
              <br/>
              BBA Auto Sales<br/>
              610 N. Cunningham Urbana, IL. 61802 <br/>
            </header>
          </div>
        </div>
        <div className='separator'>Contact Us at 217-344-2020</div>
        <div> 
        <Flex wrap justify='space-evenly' align='center'>
        <CarListings />
        <Card title="2013 Ford Edge - $5,900" variant="borderless" style={{ width: 500 }}>
          <p>100K Miles, All Power, Alloy Wheels, Great Tires, Fresh Tune Up, Oil Change.</p> 
           <Carousel arrows infinite={true}>
              <div>
              <Image width={500} src= {edge13}/>
              </div>     
              <div> 
              <Image width={500} src= {edge1301}/>
              </div>                 
              <div>
              <Image width={500} src= {edge1302}/>                 
              </div>
              <div>
              <Image width={500} src= {edge1303}/>                 
              </div>
          </Carousel>
        </Card>
        <Card title="2008 Chevrolet Silverado 1500 - $8,500" variant="borderless" style={{ width: 500 }}>
          <p>104K Miles, 4x4, Autoamtic Transmission, Alloy Wheels, Great Tires, All Power.</p> 
           <Carousel arrows infinite={true}>
              <div>
              <Image width={500} src= {silverado08}/>
              </div>     
              <div> 
              <Image width={500} src= {silverado081}/>
              </div>                 
              <div>
              <Image width={500} src= {silverado083}/>                 
              </div>
              <div>
              <Image width={500} src= {silverado084}/>                 
              </div>
          </Carousel>
        </Card>
        <Card title="2008 Nissan Altima - $5,900" variant="borderless" style={{ width: 500 }}>
          <p>134K miles, Automatic Transmission, AC, Dependable!</p> 
           <Carousel arrows infinite={true}>
              <div>
              <Image width={500} src= {nissanAltima}/>
              </div>     
              <div> 
              <Image width={500} src= {nissanAltima2}/>
              </div>                 
              <div>
              <Image width={500} src= {nissanAltima3}/>                 
              </div>
          </Carousel>
        </Card>
        <Card title="2004 Ford Mustang Convertibale - $4,900" variant="borderless" style={{ width: 500 }}>
          <p>125K Miles, V6, Leather, Electric Top.</p> 
           <Carousel arrows infinite={true}>
              <div>
              <Image width={500} src= {mustangWhite}/>
              </div>
               <div>
              <Image width={500} src= {mustangWhite2}/>                  
              </div>
          </Carousel>
        </Card>
        <Card title="2015 GMC Acadia - $12,500" variant="borderless" style={{ width: 500 }}>
          <p>105K Miles, Automatic, 3 Seat Row, All Power, Alloy Wheels, Great Condition, Great Tires.</p> 
           <Carousel arrows infinite={true}>
              <div>
              <Image width={500} src= {acadia}/>    
              </div>
              <div>
              <Image width={500} src= {acadia2}/>
              </div>
              <div>
              <Image width={500} src= {acadia3}/>             
              </div>
          </Carousel>
        </Card>
        <Card title="2022 Chevy Silverado 1500 Z71 - $55,000" variant="borderless" style={{ width: 500 }}>
          <p>Only 6,500 Miles, 4x4, Touch Screen, Bluetooth, Car Play, Heated Seats, All Options.</p> 
           <Carousel arrows infinite={true}>
              <div>
              <Image width={500} src= {silverado2022}/>                 
              </div>
          </Carousel>
        </Card>
        <Card title="2000 Ford Mustang - $15,000" variant="borderless" style={{ width: 500 }}>
            <p>95K Miles, V8 Manual, New oil change, new brakes, new exhaust, excellent condition.</p> 
            <Carousel arrows infinite={true}>
                <div>
                <Image width={500} src= {mustang1}/>                 
                </div>
                <div>
                <Image width={500} src= {mustang2}/>                 
                </div>
                <div>
                <Image width={500} src= {mustang3}/>                 
                </div>
                <div>
                <Image width={500} src= {mustang4}/>                 
                </div>
            </Carousel>
          </Card>
          <Card title="2015 Chevrolet Sonic - $5,950" variant="borderless" style={{ width: 500 }}>
            <p>130K Miles, Automatic, Front Wheel Drive, AC.</p> 
            <Carousel arrows infinite={true}>
                <div>
                <Image width={500} src= {sonic1}/>                 
                </div>
                <div>
                <Image width={500} src= {sonic2}/>                 
                </div>
                <div>
                <Image width={500} src= {sonic3}/>                 
                </div>
                <div>
                <Image width={500} src= {sonic4}/>                 
                </div>
            </Carousel>
          </Card>
          <Card title="1998 Chevrolet Silverado 1500- $4,950" variant="borderless" style={{ width: 500 }}>
            <p>87K Miles, Short Bed, 4x4, 350 Engine, Runs Well.</p> 
            <Carousel arrows infinite={true}>
                <div>
                <Image width={500} src= {silverado1}/>                 
                </div>
                <div>
                <Image width={500} src= {silverado2}/>                 
                </div>
                <div>
                <Image width={500} src= {silverado3}/>                 
                </div>
                <div>
                <Image width={500} src= {silverado4}/>                 
                </div>
            </Carousel>
          </Card>
          <Card title="2017 Ford Explorer - $7,500" variant="borderless" style={{ width: 500 }}>
            <p>X Police Car, Great Tires, 100k, Great Condition.</p> 
            <Carousel arrows infinite={true}>
                <div>
                <Image width={500} src= {police}/>                 
                </div>
            </Carousel>
          </Card>
          <Card title="2014 Cadillac CTS 4 - $12,500" variant="borderless" style={{ width: 500 }}>
            <p>120K Miles, Loaded, Leather, Front Wheel Drive, Navigation, Leather, Excellent Find.</p> 
            <Carousel arrows infinite={true}>
                <div>
                <Image width={500} src= {cts1}/>                 
                </div>
                <div>
                <Image width={500} src= {cts2}/>                 
                </div>
                <div>
                <Image width={500} src= {cts3}/>                 
                </div>
                <div>
                <Image width={500} src= {cts4}/>                 
                </div>
                <div>
                <Image width={500} src= {cts5}/>                 
                </div>
                <div>
                <Image width={500} src= {cts6}/>                 
                </div>
            </Carousel>
          </Card>
          <Card title="2018 Dodge Durango - $20,500" variant="borderless" style={{ width: 500 }}>
            <p>92K Miles, 3rd Row, AWD, Clean, 6 Cyl., 3rd Row Seat, All Power, Great Tires.</p> 
            <Carousel arrows infinite={true}>
                <div>
                <Image width={500} src= {durango181}/>                 
                </div>
                <div>
                <Image width={500} src= {durango182}/>                 
                </div>
                <div>
                <Image width={500} src= {durango183}/>                 
                </div>
                <div>
                <Image width={500} src= {durango184}/>                 
                </div>
            </Carousel>
          </Card>
          <Card title="2015 Lincoln MKC - $11,500" variant="borderless" style={{ width: 500 }}>
            <p>120K Miles, Leather, Panoramic Roof, Camera, Fresh Tune Up, New Battery.</p> 
            <Carousel arrows infinite={true}>
                <div>
                <Image width={500} src= {lincolnMKC}/>                 
                </div>
            </Carousel>
          </Card>
          <Card title="1988 Mercedes 560 SL - $12,500" variant="borderless" style={{ width: 500 }}>
            <p>81K Miles, Runs and Drives, Great, New Tires.</p> 
            <Carousel arrows infinite={true}>
                <div>
                <Image width={500} src= {mercedes560}/>
                </div>
                <div>
                <Image width={500} src= {mercedes5602}/>          
                </div>
            </Carousel>
          </Card>
          <Card title="2011 Dodge Nitro - $5,900" variant="borderless" style={{ width: 500 }}>
            <p>135K Miles, All Power, Clean, Dependable.</p> 
            <Carousel arrows infinite={true}>
                <div>
                <Image width={500} src= {nitro}/>                 
                </div>
            </Carousel>
          </Card>
          <Card title="2016 Cadillac Escalade - $30,000" variant="borderless" style={{ width: 500 }}>
            <p>82K, Premium, Loaded, 3 Seater, Fully Loaded, Excellent Condition.</p> 
            <Carousel arrows infinite={true}>
                <div>
                <Image width={500} src= {escalade1}/>
                </div>
                <div>
                <Image width={500} src= {escalade2}/>
                </div>
                <div>
                <Image width={500} src= {escalade3}/>                 
                </div>
                <div>
                <Image width={500} src= {escalade4}/>                 
                </div>
                <div>
                <Image width={500} src= {escalade5}/>                 
                </div>
                <div>
                <Image width={500} src= {escalade6}/>                 
                </div>
            </Carousel>
          </Card>
          <Card title="2011 Jeep Grd Cherokee - $10,500" variant="borderless" style={{ width: 500 }}>
            <p>144K Miles, 4x4, Leather, New Battery.</p> 
            <Carousel arrows infinite={true}>
                <div>
                <Image width={500} src= {jeepCherokee}/>
                </div>
            </Carousel>
          </Card>
          <Card title="Polaris Sportman - $5,500" variant="borderless" style={{ width: 500 }}>
            <p>136 Hours, Great Tires, Snow Plow, Electric Winch, Automatic.</p> 
            <Carousel arrows infinite={true}>
                <div>
                <Image width={500} src= {polaris}/>
                </div>
                <div>
                <Image width={500} src= {polaris2}/>
                </div>
                <div>
                <Image width={500} src= {polaris3}/>
                </div>
            </Carousel>
          </Card>
        </Flex>
        </div>
        <div>
          <div className='separator'>About Us</div>
          <Flex justify='space-evenly' align='center' vertical>
            <p className='App-info-test' style={{ maxWidth: 800 }}>BBA Auto Sales is family owned and operated. We have been part of the Urbana community for the last 30+ years. Being a small family owned dealership allows us to provide quality cars while keeping our prices low.</p>
            <p className='App-info-test' style={{ maxWidth: 800 }}>Antonio Barreda - Owner</p>
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3051.0649338166468!2d-88.20565628435764!3d40.11855638164319!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x880cd79c8a9ba8bb%3A0xbe55a6bc792bdab1!2sBBA%20Auto%20Sales%20LLC!5e0!3m2!1sen!2sus!4v1578122642967!5m2!1sen!2sus"
              width="390px"
              height="350px"
              display="initial"
              title="YouTube Video"
          />
          </Flex>
        </div>
        <div className='separator' style={{ height: 100 }}>Copyright @ 2026 BBA Auto Sales</div>
    </div>
  );
}

export default App;
